<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div class="flex-layout-column flex-layout-align-start flex-layout-gap-10px">
	<div *ngIf="hasTitle" class="filter-title">{{ title }}</div>
	<form (ngSubmit)="applyFilter()" class="flex-layout-row flex-layout-align-start-center flex-layout-gap-10px">
		<ng-content select=".filterContent"></ng-content>
		<ng-container *ngIf="showButtons">
			<div class="flex-layout-row flex-layout-align-start-center flex-layout-gap-10px action-icons">
				<span title="Apply Filter">
					<button class="filter-button primary" [attr.aria-disabled]="!hasFilters()" (click)="applyFilter()" type="submit">
						<mat-icon>filter_list</mat-icon>
					</button>
				</span>
				<button class="filter-button" (click)="resetFilter()" title="Reset Filter">
					<mat-icon>undo</mat-icon>
				</button>
			</div>
		</ng-container>
	</form>
</div>
